// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__MUOu0","content":"Layout_content__b05zb","withBottomNav":"Layout_withBottomNav__+DW0U","noBottomNav":"Layout_noBottomNav__Ncf+W"};